import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { useMediaQuery, useTheme, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import RatingStar from 'public/images/icons/rating-star';

import { Button, Avatar } from '@lc/legacy/src/Components';
import formatDate from '@lc/lib/helpers/formatDate';

import Modal from 'components/Modal';
import ViewDetail from 'components/Booking/ViewDetail';

import RatingModal from './RatingModal';
import styles from './RatingArea.style';
import RatingModalMobile from './RatingModalMobile';
import RatingAverage from './RatingAverage';

const RatingArea = ({ classes, rating, room }) => {
  const xsSize = useMediaQuery(useTheme().breakpoints.between('xs', 'sm'));
  const { t } = useTranslation(['rating']);
  const [viewDetail, setViewDetail] = useState();

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => {
    if (xsSize) {
      setViewDetail({
        title: (
          <RatingAverage totalAverage={rating.totalAverage} totalReviews={rating.totalReviews} />
        ),
        content: <RatingModalMobile rating={rating} room={room} />,
      });
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <Grid container item xs={12} spacing={2} className={classes.ratingArea}>
        <Grid container item xs={12} alignItems="center" className={classes.areaHeader}>
          <Grid item xs={1} className={classes.starWrapper}>
            <RatingStar width={15} height={14} />
          </Grid>
          <Grid item xs={11}>
            <Typography
              xs={5}
              variant="button"
              component="p"
              color="textPrimary"
              style={{ fontWeight: 700, fontSize: xsSize ? '13px' : '1em' }}
            >
              {rating.totalAverage}
            </Typography>
          </Grid>
        </Grid>

        <Grid container item xs={12}>
          {rating.reviews.map(review => (
            <Grid key={`${review.name}_${new Date().getTime()}`} container item md={6} xs={12}>
              <Grid item md={8} xs={7}>
                <Typography variant="button" color="textPrimary" className={classes.title}>
                  {t(review.name)}
                </Typography>
              </Grid>
              <Grid item md={4} xs={5}>
                <Grid container item xs={12} alignItems="center">
                  <Grid item md={8} xs={10} className={classes.percentage}>
                    <div style={{ width: `${(review.rating * 100) / 5}%` }} />
                  </Grid>
                  <Grid item md={4} xs={2}>
                    <Typography variant="button" color="textPrimary" className={classes.value}>
                      {review.rating.toFixed(1)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>

        {rating.comments.length > 0 ? (
          <Grid container item xs={12} className={classes.commentWrapper}>
            {rating.comments.map(comment => (
              <Grid key={comment.date} container item md={6} xs={12} className={classes.wrapper}>
                <Grid container item xs={12}>
                  <Grid item xs={1} style={{ minWidth: '45px' }}>
                    <Avatar
                      src={comment.avatar}
                      alt={comment.booker.split(/[, ]+/)[0].charAt(0)}
                      type="small"
                      style={{
                        marginTop: '4px',
                        paddingLeft: '1px',
                        marginLeft: '0',
                      }} />
                  </Grid>

                  <Grid item xs={9}>
                    <Grid item xs={12}>
                      <Typography variant="button" color="textPrimary" className={classes.text}>
                        {comment.booker}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="button" color="textSecondary" className={classes.text}>
                        {formatDate(comment.date, 'MMMM YYYY')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} className={classes.comments}>
                  <Typography variant="button" color="textPrimary">
                    {comment.comments}
                  </Typography>
                </Grid>

                {comment.comments.length > 120 ? (
                  <Grid onClick={handleOpen} item xs={11} className={classes.more}>
                    Ver mais...
                  </Grid>
                ) : null}
              </Grid>
            ))}

            {rating.comments.length === 4 && xsSize ? (
              <Grid
                onClick={handleOpen}
                container
                item
                md={6}
                sm={12}
                className={`${classes.wrapper} ${classes.showAllcomments}`}
              >
                Mostrar todos os comentários
              </Grid>
            ) : null}
          </Grid>
        ) : null}

        {rating.comments.length === 4 ? (
          <Grid container item xs={12} style={{ marginBottom: '13px' }}>
            <Button color="secondary" variant="outlined" onClick={handleOpen} size="xs">
              Mostrar todos os comentários
            </Button>
          </Grid>
        ) : null}
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        styleModal={{ width: '70%', maxWidth: '900px', height: '690px', overflow: 'hidden' }}
      >
        <RatingModal rating={rating} room={room} />
      </Modal>

      {viewDetail && <ViewDetail detail={viewDetail} close={() => setViewDetail(undefined)} />}
    </>
  );
};

RatingArea.propTypes = {
  classes: PropTypes.object.isRequired,
  rating: PropTypes.object.isRequired,
  room: PropTypes.string.isRequired,
};

export default withStyles(styles)(RatingArea);
